import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth'; // Check this path
// import ApiService from 'services/ApiService'; // Changed from axios to ApiService
import axios from 'axios';

const ActivityLogger = () => {
  const location = useLocation();
  const { user } = useAuth(); // Assuming 'user' object has id and compId
  const isDevelopment = process.env.NODE_ENV === 'development';

  useEffect(() => {
    const logActivity = async () => {
      if (user && user.id && user.compId) {
        // Get fresh token on each request
        const token = window.localStorage.getItem('serviceToken');

        if (!token) {
          if (isDevelopment) {
            console.warn('No auth token available for activity logging');
          }
          return;
        }

        const config = {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
          }
        };

        const payload = {
          userId: user.id,
          compId: user.compId,
          name: user.name,
          activityType: 'route_access',
          activityDetails: JSON.stringify({
            path: location.pathname,
            search: location.search,
            hash: location.hash
          })
        };

        try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user-activity-log`, payload, config);

          // 개발 환경에서만 성공 로그 출력 (민감한 정보 제외)
          if (isDevelopment) {
            console.log('Activity logged:', location.pathname);
          }
        } catch (error) {
          // 에러는 항상 로깅 (프로덕션에서도 모니터링 필요)
          console.error('Failed to log activity:', error.message);

          if (error?.response?.status === 401) {
            if (isDevelopment) {
              console.warn('Authentication failed for activity logging. Token may be expired.');
            }
          }
        }
      }
    };

    logActivity();
  }, [location, user]); // Removed config from dependencies as it's stable or should be memoized if dynamic

  return null; // This component doesn't render anything
};

export default ActivityLogger;
